import React from 'react'
import { connect } from 'react-redux'
import { InView } from 'react-intersection-observer'
import { SiteContainer } from 'core/layout'
import {
  CardsSection,
  NewsSection,
  Popup,
  FeedbackForm,
  SaitesSection,
} from 'modules'
import { Banner, GalleryPopup } from './components'
import transformData from './transformData'
import { default as SearchBlock } from 'modules/Header/components/Search/SearchBlock'

class Sakums extends React.PureComponent {
  state = {
    popup: false,
    galleryPopup: false
  };

  _onGalleryPopup = path => {
    this.setState(prevState => Object.assign({}, prevState, {
      galleryPopup: {
        open: true,
        source: path
      }
    }))
  }

  _onGalleryPopupClose = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      galleryPopup: false
    }))
  }

  _onPopup = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      popup: true
    }))
  }

  _onPopupClose = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      popup: false
    }))
  }

  render() {
    const {
      data: inputData,
      breakpoint
    } = this.props

    const { lang, teksti } = inputData
    const data = transformData(inputData, lang)
    const layout = breakpoint

    const renderSection = key => {
      const section = data.sections[key]

      const sectionProps = {
        key,
        id: key,
        data: section,
        teksti,
        layout
      }

      switch (key) {
        case 'jaunakasZinas':
          return section.items && section.items.length > 0 ? <NewsSection {...sectionProps} /> : null
        case 'saites':
          const saitesTotalCount =
            (section.aktuali ? section.aktuali.length : 0) +
            (section.noderigi ? section.noderigi.length : 0) +
            (section.temas ? section.temas.length : 0);
          return saitesTotalCount > 0 ? <SaitesSection {...sectionProps} /> : null
        default:
          return section.items && section.items.length > 0 ? <CardsSection {...sectionProps} onPopup={this._onGalleryPopup} /> : null
      }
    }

    // data nav tas pats, kas this.props.data
    const searchLapa = this.props.data && this.props.data.searchLapa

    return (
      <div>
        <Banner
          data={data.banner}
          layout={layout}
          teksti={teksti}
          onPopup={this._onPopup} />



      <InView rootMargin='-145px 0px 0px' threshold={1}>
        {({ inView, ref }) => {
          if (typeof document !== 'undefined') {
            document.body.classList.toggle('search-in-view', inView)
          }
          return (
            <div ref={ref}>
              <SearchBlock
                searchLapa={searchLapa && Array.isArray(searchLapa) && searchLapa.length > 0 && searchLapa[0]}
                lang={lang}
                teksti={teksti}
              />
            </div>
          )
        }}
      </InView>

        <main>
          <SiteContainer>
            { Object.keys(data.sections)
              .sort((a, b) => data.sections[a].order - data.sections[b].order)
              .map(key => renderSection(key)) }
          </SiteContainer>
        </main>

        {
          this.state.galleryPopup && (
            <GalleryPopup
              lang={lang}
              data={this.state.galleryPopup}
              onClose={this._onGalleryPopupClose} />
          )
        }

        {
          this.state.popup && (
            <Popup
              teksti={teksti}
              onClose={this._onPopupClose}>
              <FeedbackForm teksti={teksti} />
            </Popup>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = ({ breakpoint }) => ({
  breakpoint
})

export default connect(mapStateToProps)(Sakums)



// WEBPACK FOOTER //
// ./src/pages/Sakums/Sakums.jsx